if (!customElements.get('theme-read-more')) {
  customElements.define('theme-read-more', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-enabled')) return
      this.content = this.querySelector('.theme-text__content')
      this.button = this.querySelector('button')
      if (!this.content || !this.button) return
      this.toggle = () => {
        const expanded = this.toggleAttribute('data-expanded')
        this.button.setAttribute('aria-expanded', String(expanded))
        this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more
      }
      this.button.addEventListener('click', this.toggle)
      this.observer = new ResizeObserver(() => {
        const height = parseFloat(getComputedStyle(this).getPropertyValue('--text-preview-height'))
        const overflow = this.content.scrollHeight > height + 1
        this.toggleAttribute('data-overflow', overflow)
        this.button.hidden = !overflow
      })
      this.observer.observe(this.content)
    }
    disconnectedCallback() {
      this.observer?.disconnect()
      this.button?.removeEventListener('click', this.toggle)
    }
  })
}
